import { classNames } from '@panwds/tailwindcss';
import React from 'react';
/**
 * Provides a group layout for one or more actions.
 */
export function ActionButtonGroup({ children, className }) {
    return React.createElement("div", { className: classNames('tw-flex w-flex-row tw-justify-end tw-gap-x-2', className) }, children);
}
export default ActionButtonGroup;
//# sourceMappingURL=ActionButtonGroup.js.map